module.exports = __webpack_public_path__ + "static/img/bg_photo.7d71575.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/tab/bg_photo.png
// module id = lkMe
// module chunks = 69